import type { Copyright } from 'src/types';

export const copyright: Copyright = {
  copyright: `\u00A9 SEEK. All rights reserved`,
};
